<template>
    <Toolbar style="background-image: url('img/banner.png');background-size: 100% 100%;height:70px">
        <template #start>
            <div style="height:68px;background-color:white;">
                <img src="img/logo_EPD.png" style="height:50px;background-color:white;    margin: 10px;"
                    alt="EPD Logo" />
            </div>
            <h2 v-if="getIsLoggedIn" class="title">Web-CNMP
                {{ getCurrentProjectTitle ? `(${getCurrentProjectTitle.replaceAll('@', ' Version ')})` : "" }}</h2>
        </template>

        <template #end>
            <span v-if="getIsLoggedIn" style="color:white">Hello {{ getUser }}</span>
            <Button icon="pi pi-user" class="p-button-raised p-button-text" @click="editUser"
                v-tooltip.bottom="'Profile'" aria-label="Profile" />
            <Button icon="pi pi-users" class="p-button-raised p-button-text" @click="editMembers"
                v-tooltip.bottom="'Members'" aria-label="Members" />
            <Button v-if="isAdmin" icon="pi pi-cog" class="p-button-raised p-button-text" @click="goAdmin"
                v-tooltip.bottom="'Admin Portal'" aria-label="Admin Portal" />
            <Button icon="pi pi-question-circle" class="p-button-raised p-button-text" @click="openHelp"
                v-tooltip.bottom="'Help'" aria-label="Help" />
            <Button icon="pi pi-sign-out" class="p-button-raised p-button-text" @click="logout"
                v-tooltip.bottom="'Sign Out'" aria-label="Sign Out" />
            <Button class="p-button-raised p-button-text" style="margin-right: 20px;padding:0"
                @click="openAccessibility" v-tooltip.bottom="'Accessibility'" aria-label="Sign Out"><img
                    src="img/digital accessibility.png" alt="digital accessibility" style="width:100px;" /></Button>
        </template>
    </Toolbar>
</template>

<script>
export default {
    name: 'HeaderBar',
    methods: {
        openProjectsMenu() {
            this.$router.push('/Projects');
        },
        openEditProjectsMenu() {
            this.$router.push('/EditProjects');
        },
        async logout() {
            if (this.$store.getters.currentProject?.id) {
                const res = await this.axios
                    .post(`${this.apiEndpoint}project/close?id=${this.$store.getters.currentProject.id}`)
                console.log('project closed')
                console.log(res)
            }
            await this.axios.post(`${this.apiEndpoint}user/signout`)
            this.$store.dispatch('logout');
            this.$router.push('/Login');
            localStorage.removeItem("epd-cnmp-user")
        },
        editUser() {
            this.$router.push('/EditUser');
        },
        editMembers() {
            this.$router.push('/Members');
        },
        goAdmin() {
            this.$router.push('/Admin');
        },
        openHelp() {
            this.$router.push('/Guide');
        },
        openAccessibility() {
            this.$router.push('/Accessibility');
        }
    },
    computed: {
        getUser() {
            return this.$store.getters.currentUser.firstName;
        },
        getIsDisctrictRole() {
            return this.$store.getters.userRole == "district";
        },
        getIsLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        getCurrentProjectTitle() {
            return (this.$store.getters.currentProject) ? this.$store.getters.currentProject.projectTitle : "No Project";
        },
        isAdmin() {
            return this.$store.getters.currentUser?.userType == "admin";
        },
    }
}
</script>

<style lang="less">
.main {
    .p-toolbar {
        border-radius: 0;
        padding: 0;

        .p-button {
            margin-left: 20px;
            background: white;
            font-weight: bold;
        }

        .p-button:enabled:hover {
            background: rgb(241, 241, 241);
            font-weight: bold;
        }

        .p-button.p-button-icon-only {
            width: 3rem;
            height: 3rem;
        }

        .p-button.p-button-icon-only>span {
            font-size: 1.25rem;
        }
    }
}

.title {
    color: white;
    font-weight: bold;
    margin: 0px 20px
}
</style>